import './sentry'
import {hydrateRoot} from 'react-dom/client'

import ClientApp from './ClientApp'
import 'normalize.css'

const rootElement = document.getElementById('root')
hydrateRoot(rootElement as HTMLElement, <ClientApp />)
